module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row upper-subpanel"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'scanBarcode') ? _c('scanBarcode', {
    on: {
      "setBarcode": _vm.getBarcode
    }
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('selectDrug') : _vm._e(), (_vm.stage === 'selectPosition') ? _c('SplitLayout', [_c('DrugInfo', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }), _c('SelectBox', {
    attrs: {
      "slot": "right",
      "mode": 'emptyAndF'
    },
    slot: "right"
  })], 1) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finishAddDrug') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage === 'scanBarcode' || _vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-5",
      "title": "全部藥物"
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage = 'selectDrug'
      }
    },
    slot: "button-5"
  }) : _vm._e(), (_vm.stage === 'scanBarcode' || _vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-6",
      "title": "掃描條碼"
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage = 'scanBarcode'
      }
    },
    slot: "button-6"
  }) : _vm._e(), (_vm.stage === 'selectPosition') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "確認位置"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.confrimPosition($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a8aaeba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateDrug.vue
// module id = 1512
// module chunks = 1